<div ui-row [uiGutter]="[24, 24]">
  <div ui-col uiXs="24">
    <h4 class="sp-mb-16">Basic Input</h4>

    <input ui-input placeholder="Basic usage" [(ngModel)]="value" />
    <br />
    <br />
    <input ui-input placeholder="Basic usage" [(ngModel)]="value" [disabled]="true" />
  </div>

  <div ui-col uiXs="24">
    <h4 class="sp-mb-16">Textare Input</h4>

    <div>
      <textarea ui-input placeholder="Autosize height based on content lines" uiAutosize class="sp-mb-16"></textarea>
      <textarea ui-input placeholder="Autosize height with minimum and maximum number of lines" [uiAutosize]="{ minRows: 2, maxRows: 6 }" class="sp-mb-16"></textarea>
      <textarea ui-input placeholder="Controlled autosize" [uiAutosize]="{ minRows: 3, maxRows: 5 }" class="sp-mb-16"></textarea>
    </div>
  </div>

  <div ui-col uiXs="24">
    <h4 class="sp-mb-16">Input with Prefixes</h4>

    <ui-input-group [uiSuffix]="suffixTemplateInfo" [uiPrefix]="prefixTemplateUser">
      <input type="text" ui-input placeholder="Enter your username" />
    </ui-input-group>
    <ng-template #prefixTemplateUser><ui-icon uiType="outline:user"></ui-icon></ng-template>
    <ng-template #suffixTemplateInfo>
      <ui-icon ui-tooltip uiTooltipTitle="Extra information" uiType="outline:info-circle"></ui-icon>
    </ng-template>
    <br />
    <br />
    <ui-input-group uiSuffix="RMB" uiPrefix="￥">
      <input type="text" ui-input />
    </ui-input-group>
  </div>

  <div ui-col uiXs="24">
    <h4 class="sp-mb-16">Textarea Count</h4>
    <form ui-form [formGroup]="form" nzLayout="vertical">
      <ui-form-item>
        <ui-form-control>
          <ui-textarea-count [uiMaxCharacterCount]="100">
            <textarea rows="4" ui-input [formControlName]="'comment'"></textarea>
          </ui-textarea-count>
        </ui-form-control>
      </ui-form-item>
    </form>
  </div>
</div>
